var HOOK, PRE;

import On from 'x/On.js';

export const nowUrl = () => {
  return location.pathname.slice(1);
};

PRE = nowUrl();

HOOK = [];

export default (hook) => {
  HOOK.push(hook);
};

export const setPre = (url) => {
  PRE = url;
};

export const preUrl = () => {
  return PRE;
};

export const refresh = (url) => {
  var f;
  for (f of HOOK) {
    f(url, PRE);
  }
  setPre(url);
};

On(window, {
  popstate: () => {
    var url;
    url = nowUrl();
    if (url !== PRE) {
      refresh(url);
    }
  }
});
